import { getUrlParams, setUrlParams } from '@lux/helpers';
import CONSTANTS from '../constants/common';
import { UIAM_LANDING_WHITE_LIST_PATHS } from '../config/common';

interface UiamUrlParams {
  accessToken: string;
  targetUrl: string;
}

function extractTargetUrl(pathName: string): string | null {
  const params = new URLSearchParams(pathName);
  const targetUrl = params.get('targetUrl');
  if (!targetUrl) return null;

  const code = params.get('code');
  const group = params.get('group');
  const updatedUrl =
    code && group ? setUrlParams(targetUrl, { code, group }) : targetUrl;

  try {
    const url = new URL(updatedUrl);
    url.searchParams.delete('flowId');
    return url.toString();
  } catch {
    return null;
  }
}

export const getUiamUrlParams = (pathName: string): UiamUrlParams => {
  if (!pathName) return null;
  let accessToken, targetUrl;
  const responseQueryParams = getUrlParams(pathName);
  if (responseQueryParams?.accessToken && responseQueryParams?.targetUrl) {
    if (
      pathName.includes(`${CONSTANTS.URL_PARAMS.BTL_CAMPAIGN_ID}=`) ||
      (pathName.includes(`${CONSTANTS.URL_PARAMS.PLAN_ID}=`) &&
        pathName.includes(`${CONSTANTS.URL_PARAMS.GROUP}=mobile-share`)) ||
      UIAM_LANDING_WHITE_LIST_PATHS.some(whiteListedPath => {
        return responseQueryParams.targetUrl.includes(whiteListedPath);
      })
    ) {
      accessToken = responseQueryParams?.accessToken;
      targetUrl = extractTargetUrl(pathName);
    } else {
      accessToken = responseQueryParams?.accessToken;
      targetUrl = pathName.includes(
        `${CONSTANTS.URL_PARAMS.NEED_VALIDATE_ONE_PASS_USER}=true`
      )
        ? `${responseQueryParams?.targetUrl}=true`
        : responseQueryParams?.targetUrl;
    }
  }

  return { accessToken, targetUrl };
};
